<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RadioButton',
  props: {
    label: { type: String, required: true },
    modelValue: { type: String, required: true },
    value: { type: String, required: true },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const onChange = () => {
      emit('update:modelValue', props.value)
    }
    return {
      onChange,
    }
  },
})
</script>

<template>
  <div>
    <label class="radio">
      <input
        type="radio"
        class="radio"
        :value="value"
        :checked="modelValue === value"
        @change="onChange"
      />
      <span>{{ label }}</span>
    </label>
  </div>
</template>

<style scoped>
.radio {
  display: inline-flex;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;
  font-size: 18px;
  color: #0d0c3f; /* тёмно-синий */
}

.radio input[type='radio'] {
  display: none;
}

.radio span::before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc; /* серый для неактивного */
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
  transition: all 0.2s ease;
  background: #fff;
}

.radio input[type='radio']:checked + span::before {
  background: #ffd700; /* жёлтый */
  border-color: #ffd700;
  box-shadow: inset 0 0 0 6px #000; /* чёрная точка */
}
</style>
